import { useMemo } from 'react';
import type { OperatorStatus } from '../types';
import { useSipPhoneContext } from '../SipPhoneContext';

const STATUS_LABELS: Record<OperatorStatus, string> = {
  AVAILABLE: 'Доступен',
  BUSY: 'Занят',
  CALL: 'Разговор',
  POST_PROCESSING: 'Постобработка',
  BREAK: 'Перерыв',
  LUNCH: 'Обед',
  DND: 'Не беспокоить',
  OFFLINE: 'Офлайн',
};

export function useOperatorStatus() {
  const phone = useSipPhoneContext();
  return useMemo(() => ({
    status: phone.operatorStatus,
    label: STATUS_LABELS[phone.operatorStatus],
    setStatus: phone.setOperatorStatus,
    pending: phone.actionPending,
    options: (Object.keys(STATUS_LABELS) as OperatorStatus[]).map(value => ({ value, label: STATUS_LABELS[value] })),
  }), [phone.actionPending, phone.operatorStatus, phone.setOperatorStatus]);
}
